import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Box, Button, Container, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { CalendarMonth, ShoppingCart } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import OptimizedImage from "./OptimizedImage";
import { useState } from "react";

const items = [
  {
    description: "Uno spazio di cura per te",
    image: require("../assets/images/carousel-1.jpg"),
  },
  {
    description: "Per far fiorire il tuo potenziale",
    image: require("../assets/images/carousel-2.jpg"),
  },
  {
    description: "E vivere una vita luminosa e appagante",
    image: require("../assets/images/carousel-3.jpg"),
  },
];

export default function HeroSection() {
  const navigate = useNavigate();
  const [openCarnetModal, setOpenCarnetModal] = useState(false);

  const handleBookingClick = () => {
    navigate("/prenotazioni");
  };

  const handleCarnetClick = () => {
    setOpenCarnetModal(true);
  };

  const handleCloseModal = () => {
    setOpenCarnetModal(false);
  };

  return (
    <section>
      <Box sx={{ maxWidth: "100%", margin: "auto" }}>
        <Carousel
          infiniteLoop
          autoPlay
          interval={3000}
          showThumbs={false}
          showStatus={false}
          dynamicHeight
          stopOnHover
          className="home-carousel"
        >
          {items.map((item, i) => (
            <div key={i} style={{ position: "relative" }}>
              <OptimizedImage
                src={item.image}
                className="home-img"
                alt={`${item.description} - Immagine ${i + 1}`}
                width={1920}
                height={1080}
                loading={i === 0 ? "eager" : "lazy"}
                style={{
                  height: "auto",
                }}
              />
              <div className="carousel-overlay" />
              <h2 className="carousel-title">{item.description}</h2>
            </div>
          ))}
        </Carousel>
      </Box>

      {/* Call-to-Action Section */}
      <Container id="prenota" maxWidth="md" sx={{ py: 6, scrollMarginTop: '80px' }}>
        <Box textAlign="center">
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
           Inizia il tuo viaggio interiore
          </Typography>
          <Typography variant="h6" color="textSecondary" paragraph>
           Scegli il percorso adatto a te e prenota una lezione
          </Typography>
          <Button
            variant="contained"
            size="large"
            startIcon={<CalendarMonth />}
            onClick={handleBookingClick}
            sx={{
              mt: 3,
              py: 1.5,
              px: 4,
              fontSize: "1.1rem",
              fontWeight: "bold",
              borderRadius: "25px",
              backgroundColor: "primary.main",
              "&:hover": {
                backgroundColor: "primary.dark",
                transform: "translateY(-2px)",
              },
              transition: "all 0.3s ease-in-out",
            }}
          >
            Prenota Ora
          </Button>
        </Box>
      </Container>

    </section>
  );
}
